import api from './api';
import { transformPaginatedResponse } from './transformers';

import type { Alert } from '../types';

export interface AlertsListParams {
  page?: number;
  pageSize?: number;
  isRead?: boolean;
}

export interface PaginatedAlerts {
  count: number;
  next: string | null;
  previous: string | null;
  results: Alert[];
}

export async function fetchAlerts(params: AlertsListParams = {}): Promise<PaginatedAlerts> {
  const query: Record<string, unknown> = {};
  if (params.page !== undefined) {
    query.page = params.page;
  }
  if (params.pageSize !== undefined) {
    query.page_size = params.pageSize;
  }
  if (params.isRead !== undefined) {
    query.is_read = params.isRead ? 'true' : 'false';
  }

  const response = await api.get('/api/alerts/', { params: query });
  return transformPaginatedResponse<Alert>(response.data);
}

export async function fetchAlertsUnreadCount(): Promise<number> {
  const response = await api.get('/api/alerts/unread_count/');
  return response.data.count as number;
}

export async function markAlertsAsRead(ids: string[]): Promise<number> {
  if (ids.length === 0) {
    return 0;
  }

  const response = await api.post('/api/alerts/mark_read/', { ids });
  return response.data.marked as number;
}
